var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.7 42.9h-1.9a5.34 5.34 0 0 1-5.3-5.3v-9.5c0-.2-.2-.4-.4-.4h-1.9a1.54 1.54 0 0 1-1.5-1.5 1.54 1.54 0 0 1 1.5-1.5h1.9a3.37 3.37 0 0 1 3.4 3.4v9.5a2.26 2.26 0 0 0 2.3 2.3h1.9a1.54 1.54 0 0 1 1.5 1.5 1.54 1.54 0 0 1-1.5 1.5zm-6.6-22.8c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1.1 2.4-2.4 2.4zm0-3a.47.47 0 0 0-.5.5c0 .6 1.1.6 1.1 0-.1-.3-.4-.5-.6-.5zM30 60C13.5 60 0 46.5 0 30S13.5 0 30 0s30 13.5 30 30-13.5 30-30 30zm0-57C15.1 3 3 15.1 3 30s12.1 27 27 27 27-12.1 27-27S44.9 3 30 3z"}));
}

Info.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Info;

Info.default = Info;
